'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.quoteModel = undefined;
var _propTypes = require('prop-types');
var quoteModel = exports.quoteModel = (0, _propTypes.shape)({
  premium: _propTypes.string,
  daily: _propTypes.string
});